import React from "react";
import Heading from "../Heading/Heading";
import Box, { Props as BoxProps } from "../Box/Box";

interface Props extends BoxProps {
  label?: string;
  props?: { [key: string]: any };
  state?: { [key: string]: any };
}

const Pre: React.FunctionComponent = props => (
  <Box as="pre" sx={{ bg: "#F6F8FA", fontSize: 0, py: 2, px: 3 }} {...props} />
);

const Debug: React.FunctionComponent<Props> = ({
  label,
  props,
  state,
  ...restProps
}) => (
  <Box
    sx={{ my: 4, textAlign: "left", fontFamily: "monospace" }}
    {...restProps}
  >
    {label && (
      <Heading
        as="h3"
        sx={{
          py: 2,
          px: 3,
          bg: "black",
          color: "white",
          fontSize: 0,
          fontFamily: "body",
          textTransform: "uppercase",
        }}
      >
        {label}
      </Heading>
    )}
    {props && (
      <Pre>
        <strong>props</strong> = {JSON.stringify(props, null, 2)}
      </Pre>
    )}
    {state && (
      <Pre>
        <strong>state</strong> = {JSON.stringify(state, null, 2)}
      </Pre>
    )}
  </Box>
);

export default Debug;
